import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { CompraMadeira } from '../../types/aquisicao';
import { comprasMadeiraService } from '../../services';

const columns: ResourceColumn<CompraMadeira>[] = [
  { header: 'Fornecedor', accessor: 'fornecedor_nome' },
  { header: 'Data da compra', accessor: 'data_compra' },
  { header: 'Apta p/ estoque', render: (item) => (item.apta_para_estoque ? 'Sim' : 'Não') },
  { header: 'Itens', render: (item) => (item.itens ? item.itens.length : 0) },
];

export const ComprasMadeiraListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Compras de madeira (entrada)"
      description="Registros de entrada de madeira e geração de lotes."
      columns={columns}
      service={comprasMadeiraService}
      createPath="/admin/aquisicao/compras-madeira/novo"
      onEdit={(item) =>
        (item as { id?: number }).id &&
        navigate('/admin/aquisicao/compras-madeira/editar', { state: { record: item } })
      }
      onDelete={(item) =>
        (item as { id?: number }).id ? comprasMadeiraService.remove((item as any).id) : Promise.resolve()
      }
    />
  );
};
